import { useLocation } from 'react-router-dom';
export const useQuery = (query) => {
    const params = new URLSearchParams(useLocation().search);
    const getParam = (name) => (name ? params.get(name) : '');
    const delParam = (name) => params.delete(name);
    const addParam = (name, value) => params.append(name, value);
    const param = getParam(query);
    return {
        param,
        getParam,
        delParam,
        addParam,
    };
};
